exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lesson-chat-insert .btn.disabled[data-v-5b9eb698]{pointer-events:none;opacity:.65}", ""]);

// exports
